import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Login.css";

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [profession, setProfession] = useState("");
  const [error, setError] = useState("");
  const [isRegisterMode, setIsRegisterMode] = useState(false);

  const [profileImage, setProfileImage] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const endpoint = isRegisterMode ? "register" : "login";

    try {
      let res;

      if (isRegisterMode) {
        const formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);
        formData.append("email", email);
        formData.append("profession", profession);
        if (profileImage) {
          formData.append("profileImage", profileImage);
        }

        res = await fetch(`${API_URL}/api/${endpoint}`, {
          method: "POST",
          credentials: "include",
          body: formData,
        });
      } else {
        res = await fetch(`${API_URL}/api/${endpoint}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ username, password }),
        });
      }

      if (res.ok) {
        const data = await res.json();
        onLoginSuccess(data);
        window.location.reload();
        const origin = location.state?.from?.pathname || "/";
        navigate(origin, { replace: true });
      } else {
        const err = await res.json();
        setError(err.message || "Ein Fehler ist aufgetreten.");
      }
    } catch (err) {
      setError("Server nicht erreichbar.");
      console.error(err);
    }
  };

  const handleRemoveImage = () => {
    setProfileImage(null);
  };

  return (
    <div
      style={{ height: "100%", width: "100%" }}
      className="flex justify-center"
    >
      <div
        className="flex flex-column"
        style={{ width: "20em", gap: "1em", marginTop: "15em" }}
      >
        <span
          className="inter"
          style={{ fontWeight: "500", fontSize: "1.5em" }}
        >
          {isRegisterMode ? "Registrieren" : "Log in"}
        </span>

        <input
          className="inputField"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autofocus
        />
        <input
          className="inputField"
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {isRegisterMode && (
          <>
            <input
              className="inputField"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              className="inputField"
              type="profession"
              placeholder="Rolle"
              value={profession}
              onChange={(e) => setProfession(e.target.value)}
            />

            <div className="upload-wrapper">
              <label htmlFor="profileImage" className="upload-button">
                Profilbild auswählen
              </label>
              <input
                id="profileImage"
                type="file"
                accept="image/*"
                className="upload-input"
                onChange={(e) => setProfileImage(e.target.files[0])}
              />
              {profileImage && (
                <div className="upload-preview">
                  <img
                    src={URL.createObjectURL(profileImage)}
                    alt="Profilbild-Vorschau"
                    className="upload-thumbnail"
                  />
                  <div className="upload-info">
                    <p className="upload-filename">{profileImage.name}</p>
                    <div className="upload-remove" onClick={handleRemoveImage}>
                      <span
                        className="material-icons"
                        style={{
                          position: "relative",
                          right: "0.5em",
                          backgroundColor: "white",
                        }}
                        title="Löschen"
                      >
                        delete
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        <div className="inputButton align-end" onClick={handleSubmit}>
          {isRegisterMode ? "Registrieren" : "Login"}
        </div>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <p
          className="toggle"
          onClick={() => {
            setError("");
            setIsRegisterMode((prev) => !prev);
          }}
        >
          {isRegisterMode
            ? "Bereits registriert? Jetzt einloggen"
            : "Noch keinen Account? Jetzt registrieren"}
        </p>
      </div>
    </div>
  );
}
